import React, { useState } from 'react'
import useStyles from 'pages/User/CreateUser/CreateUserStyle'
import {
    TextField,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    Button,
    useMediaQuery,
    OutlinedInput,
    DialogActions,
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { FileCopy } from '@mui/icons-material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useSelector } from 'react-redux'

import { InviteType, UserRole, UserRoleText, USER_PROP } from '../constants'
import userActions from 'pages/User/actions'
import appActions from 'components/app/actions'
import { Link } from 'react-router-dom'
import { checkMultiEmailValid } from '../Validation'
import { AppRouteURI } from 'router/RoleBasedAccess'

const InviteEmailLinkForm = ({ handleClose }) => {
    const classes = useStyles()
    const { inviteType, selectedRole, inviteLink } = useSelector(
        (state) => state.user,
    )
    const { closeCreateDialog, sendInvite, generateInviteLink, setInviteLink } =
        userActions()
    const { setToastMessage } = appActions()
    const [selectedDate, setSelectedDate] = useState(null)
    const submitForm = (event) => {
        event.preventDefault()
        // Invite API
        if (inviteType === InviteType.EMAIL) {
            sendInvite(
                {
                    role: invite[USER_PROP.ROLE],
                    email: invite[USER_PROP.EMAIL],
                    expiry_date: selectedDate && selectedDate.getTime(),
                },
                closeCreateDialog,
            )
        }
    }
    const handleDateChange = (date) => {
        if (inviteType === InviteType.LINK) {
            setInviteLink('')
        }
        setSelectedDate(date)
    }

    const onCopyInvite = () => {
        const copyText = document.getElementById('inviteLinkInput')
        copyText.select()
        const maxRange = 200
        copyText.setSelectionRange(0, maxRange)
        document.execCommand('copy')

        setToastMessage({ message: 'Link Copied', type: 'success' })
    }
    const [isFieldChecked, setFieldChecked] = useState(false)
    const [invite, setInvite] = useState({
        [USER_PROP.ROLE]: selectedRole,
        [USER_PROP.EMAIL]: '',
    })
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <div onSubmit={submitForm}>
            <form noValidate>
                <Grid container justifyContent="space-between" spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputLabel>
                            Role
                        </InputLabel>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            label="Role"
                        >
                            <Select
                                required
                                onChange={(e) => {
                                    if (inviteType === InviteType.LINK) {
                                        setInviteLink('')
                                    }
                                    setInvite({
                                        ...invite,
                                        [USER_PROP.ROLE]: e.target.value,
                                    })
                                }}
                                value={invite[USER_PROP.ROLE]}
                                size="small"
                            >
                                {Object.keys(UserRole).map((x) => {
                                    return (
                                        <MenuItem value={UserRole[x]} key={x}>
                                            {UserRoleText[x]}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputLabel>
                            Expiry Date
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                renderInput={(params) => (
                                    <TextField
                                        fullWidth
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                color: 'rgba(0, 0, 0, 0.54) !important'
                                            },
                                        }}
                                        className={classes.inputDate}
                                        {...params}
                                        size="small"
                                    />
                                )}
                                minDate={new Date()}
                                disablePast
                                autoOk
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>

                {inviteType === InviteType.EMAIL && (
                    <div>
                        <InputLabel
                            size="small"
                            className={classes.formControl}
                        >
                            Email Address
                        </InputLabel>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                variant="outlined"
                                size="small"
                                error={
                                    isFieldChecked &&
                                    !checkMultiEmailValid(
                                        invite[USER_PROP.EMAIL],
                                    )
                                }
                                multiline
                                rows={5}
                                required
                                fullWidth
                                name="Email"
                                placeholder="name@mrc.com, email@domain.com"
                                helperText="Users will get an email that
                gives them access to the tool"
                                autoComplete="Email"
                                onClick={() => {
                                    setFieldChecked(true)
                                }}
                                onChange={(e) =>
                                    setInvite({
                                        ...invite,
                                        [USER_PROP.EMAIL]: e.target.value,
                                    })
                                }
                                value={invite[USER_PROP.EMAIL]}
                            />
                        </FormControl>
                    </div>
                )}
                {inviteType === InviteType.LINK && (
                    <div style={{ marginTop: '1.5rem' }}>
                        {/* <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.formControl}
                        >
                            <Grid item>
                                <InputLabel size="small">
                                    Click on Generate to get the link
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() =>
                                        generateInviteLink({
                                            role: invite[USER_PROP.ROLE],
                                            expiry_date:
                                                selectedDate &&
                                                selectedDate.getTime(),
                                        })
                                    }
                                    sx={{
                                        position: 'relative',
                                        top: '18px',
                                    }}
                                >
                                    Generate
                                </Button>
                            </Grid>
                        </Grid> */}
                        <FormControl
                            fullWidth
                            size="small"
                        >
                            <OutlinedInput
                                id="inviteLinkInput"
                                placeholder="https://workforce.dtn.asu.edu/invite/..."
                                variant="outlined"
                                value={inviteLink}
                                endAdornment={
                                    <InputAdornment
                                        position="end"
                                        fontSize="small"
                                    >
                                        <IconButton
                                            onClick={() => onCopyInvite()}
                                            onMouseDown={(event) => {
                                                event.preventDefault()
                                            }}
                                            edge="end"
                                        >
                                            <FileCopy />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            {/* <FormHelperText>
                                People can join Helios with a link. If you no
                                longer need this link,{' '}
                                <Link
                                    to={AppRouteURI.HOME}
                                    onClick={() => closeCreateDialog()}
                                    color="inherit"
                                >
                                    deactivate
                                </Link>{' '}
                                it
                            </FormHelperText> */}
                        </FormControl>
                    </div>
                )}
                {inviteType === InviteType.EMAIL && (
                    <Grid container justifyContent="flex-end" mt={2} gap={1}>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            fullWidth={!matches}
                            type="submit"
                            disabled={
                                !checkMultiEmailValid(invite[USER_PROP.EMAIL])
                            }
                            variant="contained"
                            color="primary"
                        >
                            Send Invite
                        </Button>
                    </Grid>
                )}

                {inviteType === InviteType.LINK && (
                    <Grid container justifyContent="flex-end" mt={2} gap={1}>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            onClick={() => generateInviteLink({
                                role: invite[USER_PROP.ROLE],
                                expiry_date:
                                    selectedDate &&
                                    selectedDate.getTime(),
                            })}
                            color="primary"
                            variant="contained"
                        >
                            Generate
                        </Button>
                    </Grid>
                )}
            </form>
        </div>
    )
}

export default InviteEmailLinkForm
